(function () {
  'use strict';

  /* @ngdoc object
   * @name crewAirportExpiryReport
   * @description
   *
   */
  angular
    .module('crewAirportExpiryReport', [
      'ui.router'
    ]);
}());
